import { render } from "./quiz-v1-self-assessment.vue?vue&type=template&id=3d50be9e"
import script from "./quiz-v1-self-assessment.vue?vue&type=script&lang=js"
export * from "./quiz-v1-self-assessment.vue?vue&type=script&lang=js"

import "./quiz-v1-self-assessment.vue?vue&type=style&index=0&id=3d50be9e&lang=sass"

import exportComponent from "../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__